import { requestConsent } from '../../scripts/consentManager';

const iframeJsClass = 'js-iframe';
const iframeButtonJsClass = iframeJsClass + '-button';

initializeIframes();

export function initializeIframes () {
    const iframeElements = document.querySelectorAll('.' + iframeJsClass) as NodeListOf<HTMLElement>;

    iframeElements.forEach((iframeElement) => {
        const service = iframeElement.querySelector('iframe')?.dataset.service;

        if (service) {
            const iframeButtonElement = iframeElement.querySelector('.' + iframeButtonJsClass) as HTMLElement;

            if (!iframeButtonElement) {
                console.error('Iframe button not found.');
                return;
            }

            iframeButtonElement.addEventListener('click', () => {
                requestConsent(service);
            });
        }
    });
}